<template>
  <div class="container">
    <!-- 节拍器主界面 -->
    <div class="metronome-main">
      <!-- 音调选择器 -->
      <div class="tone-selector-container">
        <div
          v-for="(tone, index) in beatTones"
          :key="index"
          class="tone-selector"
        >
          <el-slider
            v-model="selectBeatTones[index]"
            :min="0"
            :max="3"
            :step="1"
            vertical
            :show-stops="false"
            :show-tooltip="false"
            height="20vh"
            @change="(e) => updateTone(e, index)"
          ></el-slider>
        </div>
      </div>
      <!-- 节拍和 BPM 显示 -->
      <div class="control-container">
        <!-- 节拍模式选择 -->
        <div class="beat-control-container">
          <div class="beat-control-item">
            <div class="beat-button" @click="showDrawer = true">
              <span>{{ beatCount }}拍<i class="el-icon-arrow-down"></i></span>
            </div>
            <!-- <el-select
              v-model="beatCount"
              @change="updateBeatCount"
            >
              <el-option
                v-for="count in [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                ]"
                :key="count"
                :label="`${count}拍`"
                :value="count"
              ></el-option>
            </el-select> -->
          </div>
          <div class="beat-display">
            <div class="bpm-display">
              <el-button class="bpm-adjust-button" @click="adjustBPM(-1)">
                <i class="el-icon-remove-outline"></i>
              </el-button>
              <div class="bpm-box">
                <span class="bpm-value" @click="openBpmInput"
                  >{{ bpm }} BPM</span
                >
              </div>
              <el-button class="bpm-adjust-button" @click="adjustBPM(1)">
                <i class="el-icon-circle-plus-outline"></i>
              </el-button>
            </div>
          </div>
        </div>
        <!-- 圆形 BPM 控制 -->
        <div
          class="circle-one"
          @mousedown="startDrag"
          @mousemove="onDrag"
          @mouseup="stopDrag"
          @mouseleave="stopDrag"
          @touchstart="startDrag"
          @touchmove="onDrag"
          @touchend="stopDrag"
        >
          <div
            v-for="(line, index) in lines"
            :key="index"
            class="circle-line"
            :style="{
              transform: `translateY(-50%) rotate(${line.angle}deg)`,
              backgroundColor: index < bpm / 4 ? '#ffcc00' : '#494C55',
            }"
          ></div>
          <div class="circle-two">
            <div class="circle-three">
              <div class="circle-four">
                <div class="start-button" @click="togglePlay">
                  <img
                    :src="
                      !playing
                        ? require('@/assets/start.png')
                        : require('@/assets/pause.png')
                    "
                    style="width: 100%; height: 100%"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="circle-slider" @mousedown="startDrag" @mousemove="onDrag" @mouseup="stopDrag" @mouseleave="stopDrag"
          @touchstart="startDrag" @touchmove="onDrag" @touchend="stopDrag">
          <div class="circle-track">
            <div v-for="(line, index) in lines" :key="index" class="circle-line"
              :style="{ transform: `rotate(${line.angle}deg)` }"></div>
          </div>
          <div class="circle-thumb" :style="{ transform: `rotate(${thumbRotation}deg)` }"></div>
          <el-button class="start-button" @click="togglePlay">
            <i :class="playing ? 'el-icon-video-pause' : 'el-icon-video-play'"></i>
          </el-button>
        </div> -->
      </div>
    </div>
    <!-- BPM 输入弹窗 -->
    <el-dialog title="输入 BPM" :visible.sync="bpmInputVisible" width="300px">
      <el-input-number
        v-model="bpm"
        :min="1"
        :max="360"
        @change="updateBPM"
      ></el-input-number>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bpmInputVisible = false">取消</el-button>
        <el-button type="primary" @click="bpmInputVisible = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-drawer
      title="选择节拍"
      :visible.sync="showDrawer"
      direction="btt"
      :before-close="handleClose"
    >
      <div class="beat-picker">
        <div
          v-for="count in [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
          ]"
          :key="count"
          class="beat-picker-item"
          :class="{ active: beatCount === count }"
          @click="selectBeat(count)"
        >
          {{ count }}拍
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import * as Tone from "tone";
import "../assets/uni.webview.1.5.6";

export default {
  data() {
    return {
      showDrawer: false,
      bpm: 120, // 默认 BPM
      playing: false, // 是否正在播放
      loop: null, // Tone.js 的 Loop 引用
      time: 0,
      player: null, // 保存音频播放器实例
      pitchShift: null,
      sampler: null,
      synth: null,
      lines: [], // 圆形滑块的刻度线
      isDragging: false, // 是否正在拖动
      bpmInputVisible: false, // BPM 输入弹窗是否可见
      beatCount: 4,
      beatTones: ["C1", "C2", "C2", "C3"],
      selectBeatTones: [2, 1, 1, 1],
      toneOptions: [null, "C1", "C2", "C3"],
      time: 0,
    };
  },
  computed: {
    // 计算圆形滑块的旋转角度
    // thumbRotation() {
    //   return (this.bpm / 360) * 360; // 360 度范围
    // },
    circleProgress() {
      // 将BPM转换为0-360度的进度
      return (this.bpm / 360) * 360;
    },
  },
  watch: {
    circleProgress: {
      handler(newValue) {
        // 更新CSS变量
        document.documentElement.style.setProperty(
          "--progress",
          `${newValue}deg`
        );
        document.documentElement.style.setProperty(
          "--rotation",
          `${this.bpm}deg`
        );
        document.documentElement.style.setProperty(
          "--newRotation",
          `${this.bpm}deg`
        );
      },
      immediate: true,
    },
  },
  mounted() {
    const query = this.$route.query;
    if (query.bpm) {
      const bpm = query.bpm;
      this.bpm = bpm * 1;
    }
    // 创建音频播放器并加载音频文件
    this.player = new Tone.Player({
      url: require("@/assets/ezQ.wav"), // 替换为实际音频路径
      autostart: false, // 预加载但不自动播放
    }).toDestination();
    this.synth = new Tone.Synth().toDestination();
    this.pitchShift = new Tone.PitchShift(0); // 0 代表原始音高
    this.player.connect(this.pitchShift);
    this.pitchShift.toDestination();
    this.sampler = new Tone.Sampler({
      urls: {
        C1: require("@/assets/ezQ.wav"),
        C2: require("@/assets/tul.wav"),
        C3: require("@/assets/dLQ.wav"),
      },
      release: 1,
    }).toDestination();
    // 初始化圆形滑块的刻度线
    this.initLines();
    this.updateSliderWidth(4);
    this.disableDefaultGestures(); // 添加禁用默认手势
  },
  methods: {
    // 初始化圆形滑块的刻度线
    initLines() {
      const totalLines = 180; // 从 0 到 360，共 361 条线
      const interval = 2; // 每条线之间的间隔角度
      for (let i = 0; i < totalLines; i++) {
        if (i % interval === 0) {
          this.lines.push({
            angle: i * 2, // 每条线的旋转角度
          });
        }
      }
    },

    // 开始拖动
    startDrag(event) {
      this.isDragging = true;
      if (event.target.closest(".start-button")) {
        return;
      }
      this.updateBPMOnDrag(event);
    },

    // 拖动中
    onDrag(event) {
      if (this.isDragging && !event.target.closest(".start-button")) {
        this.updateBPMOnDrag(event);
      }
    },

    // 停止拖动
    stopDrag() {
      this.isDragging = false;
    },

    // 根据鼠标或触摸位置更新 BPM
    updateBPMOnDrag(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      // 获取鼠标或触摸的位置
      let clientX, clientY;
      if (event.touches) {
        // 触摸事件
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
      } else {
        // 鼠标事件
        clientX = event.clientX;
        clientY = event.clientY;
      }
      // 1.先得到正确的x,y
      // 2.计算正确角度
      // 3.根据+-判断在哪个象限，加上角度90, 180, 270
      // 4.最后对角度去正值然后对360取余防止出现不知名的bug
      const mouseX = clientX - centerX;
      const mouseY = centerY - clientY;

      const tureX = Math.abs(clientX - centerX);
      const trueY = Math.abs(clientY - centerY);

      // 判断在第几象限, 默认在第一象限
      let quadrant = 1;
      if (mouseX >= 0 && mouseY >= 0) {
        quadrant = 1;
      } else if (mouseX >= 0 && mouseY < 0) {
        quadrant = 2;
      } else if (mouseX < 0 && mouseY < 0) {
        quadrant = 3;
      } else if (mouseX < 0 && mouseY >= 0) {
        quadrant = 4;
      } else {
        console.log("未知错误");
      }
      let angle = 0;
      // 计算角度 要根据象限来计算
      if (quadrant === 1 || quadrant === 3) {
        angle =
          (Math.atan2(tureX, trueY) * 180) / Math.PI + 90 * (quadrant - 1);
      } else {
        angle =
          (Math.atan2(trueY, tureX) * 180) / Math.PI + 90 * (quadrant - 1);
      }
      const normalizedAngle = Math.abs(angle) % 360; // 将角度转换为 0-360 范围
      // 将角度映射到 BPM 值
      let bpm = Math.round((normalizedAngle / 360) * 360);
      if (bpm === 0) {
        bpm = 360;
      }
      this.bpm = bpm;
      this.updateBPM();
    },

    // 根据角度设置 BPM
    setBPMFromAngle(angle) {
      let bpm = Math.round((angle / 360) * 360);
      if (bpm === 0) {
        bpm = 360;
      }
      this.bpm = bpm;
      this.updateBPM();
    },

    // 调整 BPM
    adjustBPM(step) {
      let bpm = Math.min(Math.max(this.bpm + step, 0), 360);
      if (bpm === 0) {
        bpm = 360;
      }
      this.bpm = bpm;
      this.updateBPM();
    },

    // 打开 BPM 输入弹窗
    openBpmInput() {
      this.bpmInputVisible = true;
    },

    updateBeatCount(count) {
      this.beatCount = count;
      this.beatTones = Array(count).fill("C3");
      this.beatTones[0] = "C4";
      this.selectBeatTones = Array(count).fill(1);
      this.selectBeatTones[0] = 2;
      this.updateSliderWidth(count);
    },

    updateTone(e, index) {
      this.beatTones[index] = this.toneOptions[e];
    },

    // 初始化节拍器
    startMetronome() {
      if (!this.playing) {
        // 设置 BPM
        Tone.getTransport().bpm.value = this.bpm;

        // 创建一个 Loop，每拍发出一个声音
        this.loop = new Tone.Loop((time) => {
          this.playClick(time);
        }, "4n");
        // 开始播放
        this.loop.start(0);
        Tone.getTransport().start();
        this.playing = true;
      }
    },

    // 停止节拍器
    stopMetronome() {
      if (this.playing) {
        this.loop.stop();
        Tone.getTransport().stop();
        this.playing = false;
      }
    },

    // 播放节拍声音
    playClick(time) {
      // if (this.player.loaded) {
      const currentBeat = this.time % this.beatCount;
      const tone = this.beatTones[currentBeat];
      if (tone) {
        this.sampler.triggerAttackRelease(tone, "4n", time);
      }
      // if (tone) {
      //   this.sampler.triggerAttackRelease(tone, '4n')
      // }
      // const pitchMap = {
      //   "C3": -12,
      //   "C4": 0,
      //   "C5": 12
      // }; // 对应 C3、C4、C5
      // console.log(pitchMap[tone])
      // if (tone) {
      //   this.pitchShift.pitch = pitchMap[tone]; // 修改音调
      //   this.player.start(); // 复用播放器实例播放音频
      // }
      this.time++;
      // } else {
      //   console.error("音频文件未加载完成");
      // }
    },

    // 切换播放和停止
    togglePlay(e) {
      console.log(this.playing);

      if (this.playing) {
        this.stopMetronome();
      } else {
        this.startMetronome();
      }
    },

    // 更新 BPM
    updateBPM() {
      try {
        uni.postMessage({
          data: {
            bpm: this.bpm,
          },
        });
      } catch (e) {}
      if (this.playing) {
        Tone.getTransport().bpm.value = this.bpm;
      }
    },
    updateSliderWidth(sliderCount) {
      const screenWidth = window.outerWidth * 0.8;
      let width = screenWidth / sliderCount; // 计算 slider 宽度
      console.log(width, screenWidth, sliderCount, window);

      if (width > 70) {
        width = 70;
      }
      // width -= 2;
      document.documentElement.style.setProperty(
        "--slider-width",
        `${width}px`
      );
    },
    disableDefaultGestures() {
      // 禁用双击放大
      document.addEventListener(
        "touchstart",
        (event) => {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      // 禁用长按默认事件
      document.addEventListener(
        "contextmenu",
        (event) => {
          event.preventDefault();
        },
        { passive: false }
      );

      // 禁用长按选择文本
      document.addEventListener(
        "selectstart",
        (event) => {
          event.preventDefault();
        },
        { passive: false }
      );

      // 禁用双指缩放
      document.addEventListener(
        "touchmove",
        (event) => {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      // 禁用双击放大
      let lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        (event) => {
          const now = Date.now();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        { passive: false }
      );
    },
    selectBeat(count) {
      this.updateBeatCount(count);
      this.showDrawer = false;
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style scoped>
* {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.start-button,
.beat-button,
.bpm-adjust-button,
.circle-one,
.beat-picker-item {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #282933;
  font-family: Arial, sans-serif;
  color: #ffffff;
}

.metronome-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tone-selector-container {
  width: 90%;
  height: 30vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
}

.control-container {
  width: 100vw;
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #373844;
  border-radius: 6vw 6vw 0 0;
}

.beat-control-container {
  width: 100%;
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5vw;
  margin-top: 5vw;
}

.beat-control-item {
  width: 20vw;
  height: 10vw;
  margin-right: 4vw;
  background-color: #ffdc00;
  border-radius: 10vw;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 5vw;
}

:deep(.el-drawer) {
  background-color: #373844;
}
:deep(.el-drawer__header) {
  color: white;
}
:deep(.el-drawer__body) {
  color: white;
}

.beat-button {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3D3D3D;
  font-size: 5vw;
}

.beatPickerClass {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  border-radius: 20px 20px 0 0 !important;
  background-color: #373844;
  color: #ffdc00;
  max-height: 50vh !important;
}

.beat-display {
  height: 10vw;
  text-align: center;
}

.beat-info {
  font-size: 24px;
  color: #ffffff;
}

.bpm-display {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4vw;
  color: #3D3D3D;
  background-color: #ffdc00;
  border-radius: 10vw;
}

.bpm-box {
  width: 30vw;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 6vw;
}

.bpm-text {
  font-size: 4vw;
  color: #8f97ab;
}
/* .control-container>>>.beat-control-item>>>.el-select>>>.el-input>>>.el-select>>>.el-input__inner{
  height: 10vw;
} */
.bpm-box span {
  width: 100%;
  text-align: center;
}

.bpm-value {
  font-size: 5vw;
  cursor: pointer;
}

.bpm-adjust-button {
  width: 10vw;
  height: 10vw;
  padding: 0;
  background-color: #ffdc00;
  color: #000000;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bpm-adjust-button:hover {
  background-color: #ffcc00;
}

.el-icon-remove-outline {
  font-size: 6vw;
}

.el-icon-circle-plus-outline {
  font-size: 6vw;
}

.circle-one {
  position: relative;
  overflow: hidden;
  width: 60vw;
  height: 60vw;
  max-width: 400px;
  max-height: 400px;
  background-color: #545454;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .circle-one::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: conic-gradient(
    #ffdc00 var(--progress),
    transparent var(--rotation)
  );
  transition: transform 0.2s ease;
} */
/* transform: rotate(var(--rotation)); */

.circle-two {
  width: 47vw;
  height: 47vw;
  max-width: 300px;
  max-height: 300px;
  background-color: #353642;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.circle-three {
  overflow: hidden;
  position: relative;
  width: 35vw;
  height: 35vw;
  max-width: 200px;
  max-height: 200px;
  background-color: #494c55;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(var(--newRotation));
}

.circle-three::before {
  content: "";
  position: absolute;
  width: 4%;
  height: 100%;
  bottom: 50%;
  /* background: conic-gradient(#ffdc00 var(--progress), transparent var(--rotation)); */
  background-color: #ffdc00;
  transition: transform 0.2s ease;
}

.circle-four {
  width: 27vw;
  height: 27vw;
  background-color: #494c55;
  max-width: 150px;
  max-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  z-index: 5;
  transform: rotate(calc(var(--newRotation) * -1));
}

.start-button {
  width: 70%;
  height: 70%;
}

.circle-line {
  position: absolute;
  width: 4px;
  height: 60vw;
  background-color: #666;
  left: 50%;
  transform-origin: bottom;
  cursor: pointer;
}

/* 弹窗样式调整 */
.el-dialog {
  background-color: #000000;
  color: #ffffff;
}

.el-dialog__title {
  color: #ffffff;
}

.el-input-number {
  background-color: #333333;
  color: #ffffff;
}

.el-button {
  background-color: #ffdc00;
  color: #3D3D3D;
  border: none;
}

.el-button:hover {
  background-color: #ffcc00;
}

.tone-selector {
  height: 75%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 0 0.2vw;
}

.tone-selector >>> .el-slider {
  border-radius: 25px;
  overflow: hidden;
}

.tone-selector >>> .el-slider__runway {
  width: var(--slider-width) !important;
  margin: 0;
  background-color: #373844;
}

.tone-selector >>> .el-slider__bar {
  width: var(--slider-width) !important;
  background-color: #ffcc00 !important;
}

.tone-selector >>> .el-slider__button-wrapper {
  display: none !important;
  /* 隐藏滑块上的指示器 */
}

.tone-selector .el-slider__stop {
  display: none !important;
  /* 隐藏刻度点 */
}

.el-select >>> .el-input {
  font-size: 4vw;
}

.el-select >>> .el-input__inner {
  font-size: 5vw;
  height: 10vw;
  background: #ffdc00;
  color: #000000;
  padding: 0 0 0 4vw;
  text-align: left;
  border-width: 2px;
  border-radius: 10vw;
  border: none;
}

.el-select >>> .el-input__inner:hover {
  border-color: #ffdc00;
}

.el-select >>> .el-input__inner:focus {
  border-color: #ffdc00;
}

.el-select >>> .el-input__suffix {
  right: 0;
}

/* 添加以下样式来修改下箭头颜色 */
.el-select >>> .el-input__icon {
  margin-right: 1vw;
  font-size: 4vw;
  color: #000000 !important;
}

.el-select >>> .el-select__caret {
  margin-right: 1vw;
  font-size: 4vw;
  color: #000000 !important;
}

/* :deep .el-select-dropdown {
  background: #2c2c38;
  color: #ffdc00 !important;
  border-color: #ffdc00;
}

:deep .el-select-dropdown__item {
  color: #ffdc00;
}

:deep .el-select-dropdown__item:hover {
  background-color: #464660;
  color: #ffdc00;
}
:deep .el-select-dropdown__item.selected {
  background-color: #ffdc00;
  color: #2c2c38;
} */

/* 修改下拉框的定位和样式 */
.beatPickerClass {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  border-radius: 20px 20px 0 0 !important;
  background-color: #373844;
  color: #ffdc00;
  max-height: 50vh !important;
}

/* 下拉框选项样式 */
:deep(.el-select-dropdown__item) {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #ffdc00;
}

:deep(.el-select-dropdown__item.selected) {
  background-color: #ffdc00;
  color: #2c2c38;
}

:deep(.el-select-dropdown__item:hover) {
  background-color: #464660;
}

/* 添加一个新的样式规则 */
html,
body {
  overflow: hidden; /* 禁止页面滚动 */
  position: fixed; /* 固定页面位置 */
  width: 100%;
  height: 100%;
}

.beat-picker {
  padding: 20px;
}

.beat-picker-item {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  border-bottom: 1px solid #494c55;
  cursor: pointer;
}

.beat-picker-item:last-child {
  border-bottom: none;
}

.beat-picker-item.active {
  color: #ffdc00;
}

.beat-picker-item:active {
  background-color: #494c55;
}
</style>
